import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

export default function LanguageToggle() {
  const { lang, setLang } = useLanguage();

  return (
    <div className="fixed top-8 right-8 z-[100]">
      <div className="bg-zinc-900/80 backdrop-blur-md border border-zinc-800 p-1 rounded-full flex items-center shadow-2xl">
        {['es', 'en'].map((l) => (
          <button
            key={l}
            onClick={() => setLang(l)}
            className={`relative px-4 py-1.5 text-[10px] font-bold tracking-widest uppercase transition-colors duration-300 ${
              lang === l ? 'text-zinc-950' : 'text-zinc-500 hover:text-zinc-300'
            }`}
          >
            {lang === l && (
              <motion.div
                layoutId="activeTab"
                className="absolute inset-0 bg-zinc-50 rounded-full"
                transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
              />
            )}
            <span className="relative z-10">{l}</span>
          </button>
        ))}
      </div>
    </div>
  );
}